import { render } from "./gift-with-purchase.vue?vue&type=template&id=2dbf43b7"
import script from "./gift-with-purchase.vue?vue&type=script&lang=js"
export * from "./gift-with-purchase.vue?vue&type=script&lang=js"

import exportComponent from "/home/djordje/code/uwp/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__